var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentMiddleTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.162 103.475L274.275 10.084C270.758 3.361 263.379 0 256 0S241.242 3.361 237.725 10.084L188.838 103.475C80.076 127.467 0 208.012 0 304C0 418.906 114.594 512 256 512S512 418.906 512 304C512 208.012 431.924 127.467 323.162 103.475ZM256 464C141.309 464 48 392.225 48 304C48 233.168 110.166 169.982 199.178 150.348L221 145.533L256 78.672L291 145.533L312.822 150.348C401.834 169.982 464 233.168 464 304C464 392.225 370.691 464 256 464Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentMiddleTop);
export default __webpack_public_path__ + "static/media/comment-middle-top.a92509a08dc4f1f378dc1245390decc0.svg";
export { ForwardRef as ReactComponent };